import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { getAgeByBirthDate } from '../../../utils';
import { collegeProspectMinAge, collegeProspectMaxAge, PlayerProfileTabIdentifiers } from '../../../utils/constants';
import { userIsFreeOrProCollegeClubOwnerOrAdmin } from '../../../utils/user';
import {
    CppBannerPlacements,
    CppCoachActions,
    CppCoachSurfaces,
    CppPlayerActions,
    PowerFunnelGatedFeatures,
} from '../../Analytics/constants';
import useCollegeProspectAccess from '../../hooks/useCollegeProspectAccess';
import useCPPTracking from '../../hooks/useCPPTracking';
import { useCPPDynamicConfig } from '../../hooks/useCPPDynamicConfig';

const COLLEGE_CORNER_FALLBACK_PATH = '/college-corner';
const BANNER_PLACEMENT = CppBannerPlacements.HOME;

const useCppDiscoveryBanner = () => {
    const { isCollegeProspectPowerEnabled, showCppBanner } = useCPPDynamicConfig();
    const { hasAnnualPower, openUpgradePopup } = useCollegeProspectAccess();
    const { trackPlayerEngagement, trackCoachEngagement } = useCPPTracking();
    const user = useSelector((state) => state.auth?.user);
    const history = useHistory();

    if (!isCollegeProspectPowerEnabled || !showCppBanner) {
        return { variant: null, onCtaClick: null, placement: BANNER_PLACEMENT };
    }

    const coachClubMembership = userIsFreeOrProCollegeClubOwnerOrAdmin(user);
    const isCoach = !!coachClubMembership || !!user?.isCollegeCoachCppEligible;
    if (isCoach) {
        const destination = coachClubMembership?.clubId
            ? `/clubs/${coachClubMembership.clubId}`
            : COLLEGE_CORNER_FALLBACK_PATH;
        return {
            variant: 'coach',
            placement: BANNER_PLACEMENT,
            onCtaClick: () => {
                trackCoachEngagement(
                    CppCoachActions.CPP_COACH_DISCOVERY_BANNER_CLICKED,
                    CppCoachSurfaces.DISCOVERY_BANNER,
                );
                history.push(destination);
            },
        };
    }

    const age = getAgeByBirthDate(user?.claimedPlayer?.birthDate || user?.birthdate);
    const isJuniorEligibleAge = !!age && age >= collegeProspectMinAge && age <= collegeProspectMaxAge;
    if (isJuniorEligibleAge) {
        const playerId = user?.claimedPlayer?.playerId;
        return {
            variant: 'junior',
            placement: BANNER_PLACEMENT,
            onCtaClick: () => {
                trackPlayerEngagement(CppPlayerActions.CPP_DISCOVERY_BANNER_CLICKED, {
                    placement: BANNER_PLACEMENT,
                });
                if (playerId) {
                    history.push(`/profiles/${playerId}?t=${PlayerProfileTabIdentifiers.STUDENT_INFO}`);
                }
                if (!hasAnnualPower) {
                    openUpgradePopup(PowerFunnelGatedFeatures.CPP_DISCOVERY_BANNER_CTA);
                }
            },
        };
    }

    return { variant: null, onCtaClick: null, placement: BANNER_PLACEMENT };
};

export default useCppDiscoveryBanner;
